import { useEffect } from 'react';

export const useNoIndex = () => {
  useEffect(() => {
    let meta = document.querySelector('meta[name="robots"]');
    let created = false;
    let previousContent = '';

    // Check if meta tag exists, if not create it
    if (!meta) {
      meta = document.createElement('meta');
      meta.setAttribute('name', 'robots');
      document.head.appendChild(meta);
      created = true;
    } else {
      previousContent = meta.getAttribute('content') || '';
    }

    // Set noindex, follow
    meta.setAttribute('content', 'noindex, follow');

    return () => {
      // Cleanup: Remove the tag if we created it, or restore previous content
      if (created && meta && meta.parentNode) {
        meta.parentNode.removeChild(meta);
      } else if (meta) {
        if (previousContent) {
          meta.setAttribute('content', previousContent);
        } else {
          meta.removeAttribute('content');
        }
      }
    };
  }, []);
};
